import { ChangeDetectionStrategy, Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { ScCrudRules, ScTableActionSelection, ScTableAction } from '../../../../models/table.model';

@Component({
  selector: 'sc-table-cell',
  templateUrl: './sc-table-cell.component.html',
  styleUrls: ['./sc-table-cell.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ScTableCellComponent implements OnInit {
  @Input() row: any;
  @Input() col: any;
  @Input() isSelected: boolean;
  @Input() rules: ScCrudRules;
  @Output() actionSelection: EventEmitter<ScTableActionSelection> = new EventEmitter();
  @Output() checkChange: EventEmitter<any> = new EventEmitter();

  @Output() fileViewer: EventEmitter<string> = new EventEmitter();

  TableAction = ScTableAction;
  selectedTaskButtonId: number;

  @HostListener('click', ['$event'])
  public onClick(event: MouseEvent): void {
    if (this.col && (this.col.type === 'routelink' || this.col.type === 'externallink' || this.col.type === 'link')) {
      event.stopPropagation();
    }
  }

  ngOnInit() {}

  public taskComplete(row, action) {
    this.selectedTaskButtonId = action.id;
    this.actionSelection.emit({
      type: action.type,
      data: row
    });
  }
}
